//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <div class='content-wrapper'>
    <p style="font-size:16px;">Контент</p>
    <div v-if="(cmsContents != null)">
      <entity-manager :data="cmsContents" :options="cmsContentsEntityManagerOptions" style="padding-top: 20px;">
        <template slot="dataItemFieldTableView" scope="viewProps">
          <span>
            {{viewProps.dataRow.val[viewProps.column.field]}}
          </span>
        </template>

        <template slot="dataItemFieldEditView" scope="viewProps">
          <span v-if="(viewProps.fieldKey == 'name') || (viewProps.fieldKey == 'type') || (viewProps.fieldKey == 'url') || (viewProps.fieldKey == 'summary')">
            <Input v-model="viewProps.editingDataRow.val[viewProps.fieldKey]" style="width:100%"></Input>
          </span>
          <span v-else-if="(viewProps.fieldKey == 'body') || (viewProps.fieldKey == 'fields')">
            <Input v-model="viewProps.editingDataRow.val[viewProps.fieldKey]" type="textarea" :rows="10"></Input>
            <vue-html5-editor :content="viewProps.editingDataRow.val[viewProps.fieldKey]" height2="350" @change="function(val){viewProps.editingDataRow.val[viewProps.fieldKey] = val}"></vue-html5-editor>
          </span>
          <span v-else style="width:100%; height: 26px">
            {{viewProps.editingDataRow.val[viewProps.fieldKey]}}
          </span>
        </template>
      </entity-manager>
    </div>
  </div>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
/*
- используется ли поле fields? может убрать?
- здесь и в других объектах убрать createdAt? нафига? кроме content? или оставить?
- посмотреть что будет при сохранении с полем url и как на него проереагирует ядро cms?
- переименовать переменные
*/
import { mapGetters } from 'vuex'

import restResource from '@/technical/restResource'
import serverErrorHandling from '@/technical/serverErrorHandling'

import EntityManager from '@/technical/components/EntityManager'

import VueHtml5EditorModule from 'vue-html5-editor'
// help: all options are here: https://github.com/PeakTai/vue-html5-editor
const VueHtml5Editor = new VueHtml5EditorModule({
  visibleModules: [
    'text',
    'color',
    'font',
    'align',
    'list',
    'link',
    'unlink',
    // 'tabulation',
    'image',
    'hr',
    'eraser',
    'undo'
  ]
})

export default {
  data () {
    return {
      cmsContents: null,
      cmsContentsEntityManagerOptions: {
        tableColumns: [
          {title: 'id', width: '40px', field: 'id'},
          {title: 'Название', width: '', field: 'name'},
          {title: 'Тип', width: '150px', field: 'type'},
          {title: 'URL', width: '230px', field: 'url'}
        ],
        editorFields: {name: 'Название', type: 'Тип', url: 'URL', summary: 'Summary', body: 'Body', /* fields: 'Fields', */ id: 'id'},
        newEmptyEntity: function (thisRef) {
          let result = restResource(thisRef.appSettings.server.host + thisRef.appSettings.server.cmsContentResource)
          result.val = {}
          result.val.name = ''
          result.val.type = ''
          result.val.url = null
          result.val.summary = ''
          result.val.body = ''
          return result
        },
        commonDataReloadOptions: {},
        disableDelete: false
      }
    }
  },
  computed: {
    ...mapGetters([
      'appSettings',
      'commonData'
    ])
  },
  components: { EntityManager, VueHtml5Editor },
  created: function () {
    var thisRef = this

    // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! это надо выносить в общий компонент читки статических данных с сервера и занесение их в store.CommonData
    var cmsContents = []
    var cmsContentResource = restResource(thisRef.appSettings.server.host + thisRef.appSettings.server.cmsContentResource)
    cmsContentResource.query()
    .then(function (response) {
      if (response.data == null) return serverErrorHandling('что-то не так', thisRef)
      // users[0] = {Name: '- Выберите автора -', id: 0}
      for (var itemIndx = 0; itemIndx < response.data.length; itemIndx++) {
        var oneCMSContentResource = restResource(thisRef.appSettings.server.host + thisRef.appSettings.server.cmsContentResource)
        oneCMSContentResource.val = response.data[itemIndx]
        cmsContents.push(oneCMSContentResource)
      }
      thisRef.cmsContents = cmsContents
    })
    .catch((error) => serverErrorHandling(error, thisRef))
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
.content-wrapper{
  margin: 0px 0px 0px 0px; /* margin: 25px 20px 50px 20px; */
  padding: 20px;
  background: #fff; height: 100%; /* если цвет отличный от стандартной серой подложики для content или убираем серые margins, то чтобы серый прикрыть надо height=100% */
  font-family: "Roboto Light", sans-serif;
  font-size: 13px;
}
</style>

<style>
/* управляем классом внутри vue-html5-editor */
#app .vue-html5-editor .content{
  padding: 10px 10px 10px 10px;
  background: #fff;
  font-family: "Roboto Light", sans-serif;
  color:#666;
  font-size: 13px;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




// WEBPACK FOOTER //
// Content.vue?2cc2a971